/**
 * @author gll
 * 功能：类目模块
 */
import { Service } from '@/tools'

export class CategoryTaxRateService<T extends TCommodity.CategoryTaxRate> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCommodity.CategoryTaxRate}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 根据商品分类id查询类目税率信息
   * /api/commodity/categoryTaxRate/v1/findByProductCategoryId
   */
  getCategoryListTree = <K extends T['ApiFindByProductCategoryId']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiFindByProductCategoryId', data)
  // 税率管理新增 /api/commodity/categoryTaxRate/v1/insert
  insert = <K extends T['ApiInsert']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiInsert', data)

  // 查询类目税率管理信息 /api/commodity/categoryTaxRate/v1/findByProductCategoryId
  findByProductCategoryId = <K extends T['ApiFindByProductCategoryId']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiFindByProductCategoryId', data)
}
